import { faCheckDouble } from "@fortawesome/pro-solid-svg-icons/faCheckDouble";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonPublish: React.FC<MprcButtonProps> = ({ text, title, color = "success", variant = "contained", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonPublish.text;
    const lTitle = title || theme.buttons.ButtonPublish.title;

    return (
        <MprcButton
            {...rest}
            color={color}
            variant={variant}
            title={lTitle}
            text={lText}
            startIcon={<FontAwesomeIcon icon={faCheckDouble} />}
        />
    );
};
